import useIsMobile from '../../utils/hooks/useIsMobile';
import s from '../../styles/components/shows/UpcomingShows.module.css';

function formatDate(iso) {
  const d = new Date(iso + 'T12:00:00');
  return {
    month: d.toLocaleDateString('en-US', { month: 'short' }),
    day: d.getDate(),
  };
}

function ShowRow({ show, ticketBaseUrl, buttonLabel, isMobile }) {
  const date = formatDate(show.date);

  return (
    <div className={isMobile ? s.rowMobile : s.row}>
      <div className={s.date}>
        <span className={s.month}>{date.month}</span>
        <span className={isMobile ? s.dayMobile : s.day}>{date.day}</span>
      </div>

      <div className={s.details}>
        <h3 className={isMobile ? s.venueMobile : s.venue}>{show.venue}</h3>
        <p className={s.meta}>{show.city} · {show.time}</p>
        <p className={s.info}>{show.info}</p>
      </div>

      <a className={isMobile ? s.btnMobile : s.btn} href={ticketBaseUrl + show.code}>
        {buttonLabel}
      </a>
    </div>
  );
}

export default function UpcomingShows({ data }) {
  const isMobile = useIsMobile();

  return (
    <div className={s.list}>
      {data.items.map((show) => (
        <ShowRow
          key={show.code}
          show={show}
          ticketBaseUrl={data.ticketBaseUrl}
          buttonLabel={data.buttonLabel}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
}